import {cleanEntity} from "@mytour/platform";
import type {
  RdvPlanningSettingResponse,
  UpdateRdvProposalLimitPayload,
  UpdateRdvTravelSettingPayload,
} from "@mytour/shared";
import axios from "axios";

export const rdvPlanningSettingApiService = {
  async getRdvPlanningSetting(): Promise<RdvPlanningSettingResponse> {
    const result = await axios.get<RdvPlanningSettingResponse>("api/rdv/planning-setting/");
    return result.data;
  },

  async updateRdvProposalLimit(
    payload: UpdateRdvProposalLimitPayload
  ): Promise<RdvPlanningSettingResponse> {
    const result = await axios.put<RdvPlanningSettingResponse>(
      "api/rdv/planning-setting/proposal-limit",
      cleanEntity(payload)
    );
    return result.data;
  },

  async updateRdvTravelSetting(
    payload: UpdateRdvTravelSettingPayload
  ): Promise<RdvPlanningSettingResponse> {
    const result = await axios.put<RdvPlanningSettingResponse>(
      "api/rdv/planning-setting/",
      cleanEntity(payload)
    );
    return result.data;
  },
};
